import React from "react"
import styled from "@emotion/styled"
import CloseIcon from "../../assets/close.svg"

const CloseButtonWrapper = styled.button`
  position: absolute;
  top: -40px;
  right: 15px;
  color: ${props => props.theme.colors.footerFont};
  background-color: transparent;
  border-style: none;
  outline: 0;
  cursor: pointer;
`

const CloseButton = props => {
  return (
    <CloseButtonWrapper {...props}>
      <CloseIcon />
    </CloseButtonWrapper>
  )
}

export default CloseButton
